import { Injectable } from '@angular/core';
import { ShellQuery } from '@shared/store/shell.query';
import { ShellStore } from '@shared/store/shell.store';
import { SessionInfo } from '../authentication/auth.service';
import { CookieAuthService, CookieName } from '@nodeModules/@itero/auth-angular';

@Injectable({
	providedIn: 'root',
})
export class ShellContextFacade {
	constructor(
		private shellQuery: ShellQuery,
		private shellStore: ShellStore,
		protected cookieAuthService: CookieAuthService
	) {}

	get sessionInfo(): SessionInfo {
		const context = this.shellQuery.getValue().context;

		const { sessionId, sessionType } = context.session;
		const { accessToken } = context.security;
		const idToken = String(this.cookieAuthService.getCookie(CookieName.IDTOKEN));

		return {
			sessionId,
			sessionType,
			accessToken,
			idToken,
		};
	}

	get companyId(): number {
		const context = this.shellQuery.getValue().context;

		return context?.bizCtx?.companyId;
	}

	get contactId(): number {
		const context = this.shellQuery.getValue().context;

		return context?.bizCtx?.contactId;
	}

	updateSessionInfo(sessionInfo: SessionInfo) {
		this.shellStore.update(state => {
			state.context.session.sessionId = sessionInfo.sessionId;
			state.context.session.sessionType = sessionInfo.sessionType;
			state.context.security.accessToken = sessionInfo.accessToken;

			if (sessionInfo.idToken) {
				this.cookieAuthService.setCookie(CookieName.IDTOKEN, sessionInfo.idToken);
			}
		});
	}
}
